import fetcher from 'api/fetcher';
import { endOfMonth } from 'date-fns';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import {
    Act,
    ActAdvertisingServiceType,
    ActProcessingType,
    ActStatus,
    ActType,
    setActs,
    setLoadActs,
    setSortActs,
} from 'store/models/acts';
import { AppThunkAction } from 'store/utils';

export const fetchActs = (isEditingActsPage: boolean, abortSignal?: AbortSignal): AppThunkAction => {
    return (dispatch, getState) => {
        const state = getState();
        const {
            currentDate,
            statuses,
            selectTypes,
            advertisingServiceType,
            processingType,
            employerId,
            accountId,
            from,
            to,
        } = state.acts;
        dispatch(setLoadActs(true));
        const queryStr = urlParser.stringify({
            dateFrom: isEditingActsPage ? formatDate(from) : formatDate(currentDate),
            dateTo: isEditingActsPage ? formatDate(to) : formatDate(endOfMonth(currentDate)),
            type: selectTypes === ActType.All ? '' : selectTypes,
            status: statuses === ActStatus.All ? '' : statuses,
            advertisingServiceType:
                advertisingServiceType === ActAdvertisingServiceType.All ? '' : advertisingServiceType,
            processingType: processingType === ActProcessingType.All ? '' : processingType,
            employerId,
            accountId,
        });

        return fetcher
            .get<unknown, Act[]>(`/api/v1/reports/acts/monthly?${queryStr}`, {
                signal: abortSignal,
                timeout: 300000,
            })
            .then((acts) => {
                dispatch([setActs(acts), setSortActs(new Map()), setLoadActs(false)]);
            })
            .catch((error) => console.error('Fetch Acts', JSON.stringify(error)));
    };
};
